// src/services/cashier-order.service.ts
// Cashier money movements run server-side (callables) so balances always have ledger records
// and clients never write wallets / wallet_transactions directly.
import { call, callableMessage } from "./callables";

/**
 * Settle cashier wallet (end of day): marks the cashier's "due" collections as settled,
 * moves them into the cashier wallet balance and records a ruchira settlement entry.
 */
export async function settleCashierWallet(_cashierUid?: string): Promise<{
  settled: boolean;
  settledAmount: number;
  transactionCount: number;
}> {
  try {
    return await call("cashierSettle", {});
  } catch (e: any) {
    throw new Error(callableMessage(e, "Settlement failed"));
  }
}
